import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<Saas::SaasSharedUiShim @componentName=\"UpsellPaywallFullPage\" @feature={{this.feature}} @onActivate={{this.onActivate}} @onClick={{this.onClick}} @shimTag={{this.shimTag}}>{{yield}}</Saas::SaasSharedUiShim>", {
  moduleName: "@dashboard/shared-ui/components/saas/upsell-paywall-full-page.hbs"
});